import './Footer.css'
import CopyrightIcon from '@material-ui/icons/Copyright'

const Footer = () => (
  <footer className='footer'>
    <a
      href='/'
      className='link footer__link'
    >
      © Varun Sekar
    </a>
  </footer>
)

export default Footer
